import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CannyApiService, GetSingleSignOnResponse } from '@vendasta/partner';

@Injectable({ providedIn: 'root' })
export class CannyService {
  constructor(private api: CannyApiService) {}

  getSingleSignOn(userId: string): Observable<GetSingleSignOnResponse> {
    return this.api.getSingleSignOn({ userId: userId });
  }
}
